<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import BaseButton from '@/components/common/BaseButton.vue'
import { useAuthStore } from '@/stores/auth'
import { PhPencil } from '@phosphor-icons/vue'

defineOptions({ name: 'ListingOrderCta' })

defineProps<{
  listingId: string
  canOrder: boolean
  isOwner: boolean
  loading: boolean
}>()

defineEmits<{ order: [] }>()

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()
</script>

<template>
  <BaseButton
    v-if="canOrder"
    variant="primary"
    size="lg"
    class="flex-1 max-w-xs lg:max-w-none"
    :loading="loading"
    @click="$emit('order')"
  >
    Continue
  </BaseButton>

  <BaseButton
    v-else-if="isOwner"
    variant="secondary"
    size="lg"
    class="flex-1 max-w-xs lg:max-w-none"
    @click="() => router.push(`/edit-listing/${listingId}/`)"
  >
    <PhPencil class="w-5 h-5 mr-2" />
    Edit Listing
  </BaseButton>

  <BaseButton
    v-else-if="!authStore.isAuthenticated"
    variant="primary"
    size="lg"
    class="flex-1 max-w-xs lg:max-w-none"
    @click="() => router.push({ path: '/login/', query: { redirect: route.fullPath } })"
  >
    Login to Order
  </BaseButton>

  <BaseButton
    v-if="!canOrder && authStore.isAuthenticated"
    variant="primary"
    size="lg"
    class="flex-1 max-w-xs lg:max-w-none"
    disabled
  >
    {{ isOwner ? 'Your Listing' : 'Not Available' }}
  </BaseButton>
</template>
